import { Loom } from './Loom';
import { Supademo } from './Supademo';
import { Typeform } from './Typeform';
import { YouTube } from './Youtube';
import { Wistia } from './Wistia';
import { Vimeo } from './Vimeo';
import { NativeVideo } from './NativeVideo';
const embedComponents = [
  Loom,
  Supademo,
  Typeform,
  YouTube,
  Wistia,
  Vimeo,
  NativeVideo,
];

export const EmbedComponent = (href: string, isAttachmentVideo?: boolean) => {
  // Skip checking for all possible embedding if `href` is proven a video attachment
  if (isAttachmentVideo) {
    return NativeVideo({ attrs: { href } });
  }

  for (const Embed of embedComponents) {
    const isMatch = Embed.isMatch(href);
    if (isMatch) {
      return Embed({ attrs: { href } }); // Generate the embed HTML
    }
  }

  return null; // Return null if no match is found
};
export default EmbedComponent;
